// To generate a new file similar to this one, run `pay js:run gql-v1 --type=mutation --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import {gql} from '@sail/data';
import {useV1Mutation} from '@stripe-internal/data-v1';

import type {GraphQlDocument, HookVariables} from '@sail/data';

import type {
  V1MutationOptions,
  V1MutationOptionsWithoutVariables,
  V1MutationReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  OpenapiPostV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmitInput,
  V1ContextInput,
  OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionStateEnum,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  mutation SubmitReturnDetailsCollectionSessionMutation(
    $input: OpenapiPostV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmitInput!
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmit(
      input: $input
      v1Context: $v1Context
    ) {
      id
      state
      submittedWalletAddress: submitted_wallet_address_redacted
    }
  }
`;

export const submitReturnDetailsCollectionSessionMutation: SubmitReturnDetailsCollectionSessionMutationDocument =
  doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const submitReturnDetailsCollectionSessionMutationOptions: V1MutationOptionsWithoutVariables<SubmitReturnDetailsCollectionSessionMutationDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useSubmitReturnDetailsCollectionSessionMutation<
  THookVariables extends HookVariables<SubmitReturnDetailsCollectionSessionMutationVariables> = {},
>(
  options: V1MutationOptions<
    SubmitReturnDetailsCollectionSessionMutationDocument,
    THookVariables
  > = {},
): V1MutationReturn<
  SubmitReturnDetailsCollectionSessionMutationDocument,
  THookVariables
> {
  return useV1Mutation(submitReturnDetailsCollectionSessionMutation, {
    ...submitReturnDetailsCollectionSessionMutationOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type SubmitReturnDetailsCollectionSessionMutationVariables = Exact<{
  input: OpenapiPostV1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmitInput;
  v1Context: V1ContextInput;
}>;

export type SubmitReturnDetailsCollectionSessionMutationData = {
  readonly __typename: 'Mutation';
  readonly v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmit: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSession';
    readonly id: string;
    readonly state: OpenapiCryptocurrencyPayinsResourceReturnDetailsCollectionSessionStateEnum;
    readonly submittedWalletAddress: string | null;
  } | null;
};

export type SubmitReturnDetailsCollectionSessionMutationToken = AccountToken<{
  Mutation_v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSessionSubmit: true;
}>;

export type SubmitReturnDetailsCollectionSessionMutationDocument =
  GraphQlDocument<
    SubmitReturnDetailsCollectionSessionMutationData,
    SubmitReturnDetailsCollectionSessionMutationVariables,
    SubmitReturnDetailsCollectionSessionMutationToken
  >;
